import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '@/components/LanguageSelector';

export default function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-navy via-primary-800 to-primary-600 flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary-400/10 rounded-full blur-3xl animate-pulse-glow" />
        <div className="absolute bottom-10 right-20 w-96 h-96 bg-accent-green/10 rounded-full blur-3xl animate-pulse-glow" style={{animationDelay: '1s'}} />
      </div>

      {/* Language selector - top right */}
      <div className="absolute top-4 right-4 z-20">
        <LanguageSelector />
      </div>

      <div className="w-full max-w-md relative z-10">
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/20 p-8 animate-slide-in">
          <div className="flex flex-col items-center justify-center mb-6">
            <img src="/logo.png" alt="HACCP APP" className="w-24 h-24 object-contain" />
          </div>

          <Outlet />

          <div className="mt-8 pt-6 border-t border-neutral-200 text-center">
            <p className="text-xs text-neutral-600">{t('common.copyright')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
